import { Menu } from '@mantine/core';
import IconCornerRightUp from '@tabler/icons-react/dist/esm/icons/IconCornerRightUp.mjs';
import IconCornerRightUpDouble from '@tabler/icons-react/dist/esm/icons/IconCornerRightUpDouble.mjs';
import IconCornerRightDown from '@tabler/icons-react/dist/esm/icons/IconCornerRightDown.mjs';
import IconCornerRightDownDouble from '@tabler/icons-react/dist/esm/icons/IconCornerRightDownDouble.mjs';
import { useTranslation } from 'react-i18next';
import type { GraphRendererApi } from '@/shared/ui/graph-renderer';

export const GraphGroupMenuItems = ({
  api,
  nodeId,
  close,
}: {
  api: GraphRendererApi;
  nodeId: string;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const views = api.views;
  if (!views) return null;
  const group = views.isGroup(nodeId);
  const collapsed = views.isCollapsed(nodeId);
  const actions = collapsed
    ? [
        { key: 'expand', icon: IconCornerRightDown, recursive: false },
        ...(!group
          ? [
              {
                key: 'expandRecursively',
                icon: IconCornerRightDownDouble,
                recursive: true,
              },
            ]
          : []),
      ]
    : group
      ? [
          { key: 'collapse', icon: IconCornerRightUp, recursive: false },
          {
            key: 'collapseRecursively',
            icon: IconCornerRightUpDouble,
            recursive: true,
          },
        ]
      : [];
  return (
    <>
      {actions.map(({ key, icon: Icon, recursive }) => (
        <Menu.Item
          key={key}
          data-testid={
            key.replace('Recursively', '-recursively') + '-menu-item'
          }
          leftSection={<Icon />}
          onClick={() => {
            if (collapsed) views.expand(nodeId, recursive);
            else views.collapse(nodeId, recursive);
            close();
          }}
        >
          {t('graphViews.actions.' + key, { ns: 'srm' })}
        </Menu.Item>
      ))}
    </>
  );
};
